import { MarkdownView } from '@/global/components/Markdown/MarkdownView'
import Dialog from '@/global/guides/Dialog'
import type { NotificationVisualMessage } from '@/service/api/endpoints/notificacoes'
import { useNavigate } from 'react-router-dom'

interface ModalCampanhaProps {
    notificacao: NotificationVisualMessage
    /** Chamado ao fechar ou ao clicar no botão primário para registrar ciência. */
    onEncerrar: () => void
}

/** Exibe o conteúdo rico de uma campanha e registra sua ciência ao encerrar. */
export function ModalCampanha({ notificacao, onEncerrar }: ModalCampanhaProps) {
    const navigate = useNavigate()
    const { botao } = notificacao

    function handleSubmit() {
        if (!botao) return

        if (botao.url.startsWith('http')) {
            window.open(botao.url, '_blank', 'noopener noreferrer')
            return
        }

        // '//host' e '/\host' são normalizados pelo browser
        if (/^\/(?![/\\])/.test(botao.url)) navigate(botao.url)
    }

    return (
        <Dialog.Root
            open
            onClose={onEncerrar}
            onSubmit={botao ? handleSubmit : undefined}
        >
            <Dialog.Title>{notificacao.title}</Dialog.Title>
            <Dialog.Content>
                {notificacao.corpoMarkdown ? (
                    <MarkdownView campanhaId={notificacao.campanhaId}>
                        {notificacao.corpoMarkdown}
                    </MarkdownView>
                ) : (
                    <p className="text-sm">{notificacao.message}</p>
                )}
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
                {botao && (
                    <Dialog.Actions.PrimaryButton closeOnSubmit>
                        {botao.label}
                    </Dialog.Actions.PrimaryButton>
                )}
            </Dialog.Actions>
        </Dialog.Root>
    )
}
